/* This is to standardize how product type is dealt with */
export enum GenericProductType {
  Auto,
  Home,
  Life,
  Mixed,
  Other,
  Umbrella
}
